import React, { useEffect, useState } from "react";
import logoImage from "../../assests/images/logo.png";
import userImage from "../../assests/images/default_avatar.png";
import NotificationsRoundedIcon from "@mui/icons-material/NotificationsRounded";
import Button from "@mui/material/Button";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import Stack from "@mui/material/Stack";
import { Link, useLocation } from "react-router-dom";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useNavigate } from "react-router-dom";
import { notificationServices } from "../../services/notificationServices";
import { useRef } from "react";
import { strToDate } from "../../constant";
import { UserObj } from "../../services/localStarage";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import MenuIcon from "@mui/icons-material/Menu";
import Sidebar from "../sidebar/sidebar";
import useMediaQuery from "@mui/material/useMediaQuery";
import { adminServices } from "../../services/adminServices";
import AlertComponent from "../../views/alert/alert";
import CloseIcon from "@mui/icons-material/Close";
import Modal from "@mui/material/Modal";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { isEmptyDash } from "../../constant";
import { authServices } from "../../services/authServices";
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import io from 'socket.io-client';
import { SOCKET_SERVER_URL } from "../../constant";
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
import SwipeableDrawer from "@mui/material/SwipeableDrawer";

function AdminNavbar(props) {
  const wrapperRef = useRef(null);
  const [open, setOpen] = React.useState(false);
  const accordionCount = 16;
  const [openAccordions, setOpenAccordions] = useState(
    Array.from({ length: accordionCount }, () => false)
  );
  const [isNotificationOpen, setIsNotificationOpen] = React.useState(false);
  const [notificationCount, setNotificationCount] = React.useState(0);
  const [notifications, setNotifications] = React.useState([]);
  const [profileData, setprofileData] = React.useState("");
  const anchorRef = React.useRef(null);
  const [createVendorOpen, setCreateVendorOpen] = useState(false);
  const [credential, setCredential] = useState({
    password: "",
    confirmPassword: "",
  });
  const [isPassword, setIsPassword] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [showResetSuccessModal, setShowResetSuccessModal] = useState(false);
  const isMobile = useMediaQuery("(max-width:800px)");
  let navigate = useNavigate();
  const navigateUrl = (param) => {
    props?.handleNavigation(`${param}`);
    // navigate(param);
  };
  const [alertComponent, setAlertComponent] = React.useState({
    open: false,
    message: "",
    type: "",
  });
  const [page, setPage] = useState(1);
  const [isConnected, setIsConnected] = useState(false);

  const token = `${UserObj?.accessToken}`;
  const socket = io(SOCKET_SERVER_URL, {
    auth: {
      token: token
    }
  });

  useEffect(() => {
    socket.on('connect', () => {
      const engine = socket.io.engine;
      setIsConnected(true);
    });

    socket.on('connect_error', (error) => {
    });
    socket.on('disconnect', () => {
      setIsConnected(false);
    });
    return () => {
      socket.disconnect();
    };
  }, []);
  socket.on('receive-notification', (notification) => {
    setNotifications((prevNotifications) => [notification, ...prevNotifications]);
    setNotificationCount((prevCount) => prevCount + 1);
  });


  // React.useEffect(() => {
  //   notificationServices
  //     .getNotificationList(`?pageNo=1`)
  //     .then(function (response) { 
  //       if (response?.data?.success === true) {
  //         setNotification(response?.data?.data?.notifications);
  //         setNotificationCount(response?.data?.data?.notificationsCount);
  //       } else {
  //         setNotificationCount([]);
  //       }
  //     })
  //     .catch(function (error) { 
  //       setNotificationCount([]);
  //     });
  // }, []);

  const loadNotifications = async () => {
    setIsLoading(true);
    try {
      const response = await notificationServices.getNotificationList(`?pageNo=${page}`);
      console.log(response);
      if (response?.data?.success === true && response?.data?.data?.notificationsCount > 0) {
        const newNotifications = response?.data?.data?.notifications || [];
        // if (response?.data?.data?.notificationsCount > 0) {
        setNotifications((prevNotifications) => [
          ...prevNotifications,
          ...newNotifications,
        ]);
        // }
        setNotificationCount(response?.data?.data?.notificationsCount);
      } else {
        setNotificationCount(response?.data?.data?.notificationsCount);
      }
    } catch (error) {
      setNotificationCount(0);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadNotifications();
  }, [page]);

  useEffect(() => {
    const handleScroll = () => {
      console.log('asdfadsfadsf');
      if (wrapperRef.current) {
        const { scrollTop, scrollHeight, clientHeight } = wrapperRef.current;
        if (scrollTop + clientHeight >= scrollHeight && !isLoading) {
          if (notificationCount !== 0) {
            setPage(prevPage => prevPage + 1);
          }
        }
      }
    };
    const wrapperRefCurrent = wrapperRef.current;
    if (wrapperRefCurrent) {
      wrapperRefCurrent.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (wrapperRefCurrent) {
        wrapperRefCurrent.removeEventListener("scroll", handleScroll);
      }
    };
  }, [isLoading]);

  /**
   * Hook that alerts clicks outside of the passed ref
   */
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        const container = document.querySelector(
          ".lets_invited_notifiaction_redirect_react_block"
        );
        if (container && !container.contains(event.target)) {
          setIsNotificationOpen(false);
        } else {
          // setIsNotificationOpen(true);
        }
      } else {
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };
  const clearNotification = () => {
    notificationServices
      .clearNotificationList()
      .then(function (response) {
        setIsNotificationOpen(false);
        setNotificationCount(response?.data?.data?.notificationsCount);
        // if (isArray(response?.data?.data)) {
        //   setNotificationCount(response?.data?.data);
        // } else {
        //   setNotificationCount([]);
        // }
      })
      .catch(function (error) {
        // setNotificationCount([]);
      });
    // setIsNotificationOpen(false);
  };

  const inviteModalClose = () => {
    setCreateVendorOpen(false);
  };

  const handleClose = (event) => {
    if (event) {
      if (anchorRef.current && anchorRef.current.contains(event.target)) {
        return;
      }
    } else {
      setAlertComponent({ ...alertComponent, open: false });
    }

    setOpen(false);
  };

  const logout = (event) => {
    sessionStorage.removeItem("user");
    sessionStorage.removeItem("isAlertUnsavedData");
    handleClose(event);
    navigate("/auth/login");
  };

  const handleRedirect = () => {
    const role = UserObj.role.name;
    if (role === "VENDOR") {
      // navigate("/admin/welcome");
      props?.handleNavigation(`/admin/welcome`);
    } else {
      // navigate("/admin/dashboard");
      props?.handleNavigation(`/admin/dashboard`);
    }
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === "Escape") {
      setOpen(false);
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);

  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef?.current?.focus();
    }
    prevOpen.current = open;
  }, [open]);

  // sidebar menu

  const [opensidebarmenu, setOpenSidebarMenu] = React.useState(false);

  const toggleDrawer = (newOpen) => () => {
    setOpenSidebarMenu(newOpen);
  };

  // const DrawerList = (
  //   <Box sx={{ width: 250 }} role="presentation" onClick={toggleDrawer(false)}>
  //     <List>
  //       {["Inbox", "Starred", "Send email", "Drafts"].map((text, index) => (
  //         <ListItem key={text} disablePadding>
  //           <ListItemButton>
  //             <ListItemIcon>
  //               {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
  //             </ListItemIcon>
  //             <ListItemText primary={text} />
  //           </ListItemButton>
  //         </ListItem>
  //       ))}
  //     </List>
  //     <Divider />
  //     <List>
  //       {["All mail", "Trash", "Spam"].map((text, index) => (
  //         <ListItem key={text} disablePadding>
  //           <ListItemButton>
  //             <ListItemIcon>
  //               {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
  //             </ListItemIcon>
  //             <ListItemText primary={text} />
  //           </ListItemButton>
  //         </ListItem>
  //       ))}
  //     </List>
  //   </Box>
  // );

  const openNotification = () => {
    setIsNotificationOpen(!isNotificationOpen);
  };

  const loginId = UserObj._id;
  useEffect(() => {
    getProfileDetails(loginId);
  }, [loginId]);

  const getProfileDetails = (loginId) => {
    if (loginId) {
      adminServices
        .getProfileData(loginId)
        .then((res) => {
          if (res.data.success === true) {
            setprofileData(res.data.data);
          } else {
            setAlertComponent({
              open: true,
              type: "error",
              message: `No Data Found `,
            });
          }
        })
        .catch(function (error) {
          setAlertComponent({
            open: true,
            type: "error",
            message: `${error?.response?.data?.message}`,
          });
        })
        .finally((param) => {
          // setIsLoading(false);
        });
    }
  };

  const onInputChange = (e) => {
    const { name, value } = e.target;
    setCredential((prevCredential) => ({
      ...prevCredential,
      [name]: value,
    }));
  };
  const passwordViewChange = () => {
    setIsPassword((prevIsPassword) => !prevIsPassword);
  };
  const changePasswordModael = () => {
    setCreateVendorOpen(true);
    setOpen(false);
  };
  const submitResetPassword = () => {
    if (isEmptyDash(credential?.password)) {
      openAlert(true, "error", `Please Enter Password.`);
      return;
    }
    if (isEmptyDash(credential?.confirmPassword)) {
      openAlert(true, "error", `Please Enter Confirm Password.`);
      return;
    }

    if (credential?.password === credential?.confirmPassword) {
      let obj = {
        password: credential?.password,
      };
      setNewPassword(obj, UserObj?.accessToken);

      // setShowResetSuccessModal(true); // Show the reset success modal
    } else {
      openAlert(true, "error", `Please enter same Password.`);
      return;
    }
    // props.submitResetPassword(2);
  };

  const setNewPassword = (data, token) => {
    setIsLoading(true);
    authServices
      .createPassword(data, token)
      .then(function (response) {
        setShowResetSuccessModal(true);
        openAlert(
          true,
          "success",
          `Your password has been changed successfully.Please login Again`
        );
        setCreateVendorOpen(false);
        setTimeout(() => {
          logout(); // Call the logout function after 10 seconds
        }, 2000);
      })
      .catch(function (error) {
        openAlert(true, "error", `${error?.response?.data?.message}`);
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };
  const openAlert = (open, type, message) => {
    setAlertComponent({ open, type, message });
  };
  const comingPopup = () => {
    openAlert(true, "success", "coming soon....");
  };

  const notifiURL = (uniqueName) => {
    switch (uniqueName) {
      case 'PACKAGE_DETAIL':
        return '/admin/Project-Manager-Package-Detail';
      case 'RFQ_DETAIL_INTERNAL':
        return '/admin/Buyer-Bidding-Rfq-Creaction-Form';
      case 'RFQ_DETAIL_VENDOR':
        return '/admin/Buyer-Bidding-Rfq-Creaction-Form';
      case 'PROJECT_DETAIL':
        return '/admin/Project-Manager-Listing';
      default:
        return '#';
    }
  }
  const handleNotificationClick = (index) => {
    const updatedNotifications = [...notifications];

    if (!updatedNotifications[index].read) {
      updatedNotifications[index].read = true;
      setNotificationCount(prevCount => prevCount - 1);
    }

    setNotifications(updatedNotifications);
  }
  const userRole = UserObj.role.name;

  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const toggleDrawer1 = (anchor, open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };

  const list = (anchor) => (
    <Box
      sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 311 }}
      role="presentation"
      onClick={toggleDrawer1(anchor, false)}
      onKeyDown={toggleDrawer1(anchor, false)}
    >
      <List>
        <div className="dropdown" >
          <div>
            <div className="notifications_heading justify-content-between">
              Notifications
              {notificationCount > 0 && (
                <span
                  onClick={clearNotification}
                  name="clear"
                  id="clear"
                >
                  Clear
                </span>
              )}
            </div>
            <div className="notifications_inside notification-height-css time_outer_notifi" ref={wrapperRef}>
              {notifications.map((ele, index) => (
                <>
                    <div className="time_outer">
                    <img src="images/time.png" alt="" />{" "}
                    <AccessTimeIcon /><span>{strToDate(ele?.createdAt)}</span>
                  </div>
                  <ListItem  key={index} disablePadding>
                    <ListItemButton>
                      {ele?.data?.uniqueName ?
                        <Link className="notifications_inside_link"  href={`${notifiURL(ele?.data?.uniqueName)}/${ele?.data?.referenceId}`} onClick={() => handleNotificationClick(index)}>
                          <ListItemText primary={ele?.message} />
                        </Link>
                        : <ListItemText primary={ele?.message} />
                      }
                    </ListItemButton>
                  </ListItem>
                </>
              ))}
              {notificationCount < 1 && (
                <div className="empty-notification">
                  No Notification Found
                </div>
              )}
              {isLoading && (
                <div className="loading">
                  Loading more notifications...
                </div>
              )}
            </div>
          </div>
        </div>
      </List>
    </Box >
  );
  
  return (
    <>
      <header>
        <div className="container-fluid">
          <div className="navbarRow1">
            <div className="col">
              <div className="lets_first_menu_react_sidebar_toogler">
                <div className="lets_left_menu_toggler_drawer">
                  <Button onClick={toggleDrawer(true)}>
                    <MenuIcon className="lets_menu_ico" />
                  </Button>
                  <Drawer
                    className="left_menu_block_react_sidebar"
                    open={opensidebarmenu}
                  >
                    {/* {DrawerList} */}
                    <div className="admin_navbar_sidebar_react_blocklist">
                      <img
                        alt=""
                        src={logoImage}
                        className="logo_lets_block_react_sidebar"
                      />
                      <CloseIcon
                        onClick={toggleDrawer(false)}
                        className="close_icon_react_sidebar"
                      />
                    </div>
                    <Sidebar className="left_menu_block_reacts" handleNavigation={props?.handleNavigation} />
                  </Drawer>
                </div>
                <img src={logoImage} onClick={handleRedirect} alt="logo" style={{ cursor: 'pointer' }} />
              </div>
            </div>
            <div className="col ms-auto invites_log1">
              <div className="lets_invited_notifiaction_redirect_react_block">
                <div className="notification">
                  <div>
                    {['right'].map((anchor) => (
                      <React.Fragment key={anchor}>
                        {/* <Button onClick={toggleDrawer1(anchor, true)}>{anchor}</Button> */}
                        <div className="lets_block_api_redirect_navbar">
                          {/* {userRole === "VENDOR" && (
                              <div className="" onClick={comingPopup}>
                                <p className="notification_invites_image_react_colume">
                                  <img src={invitedImage} alt="Invite" /> Invites
                                </p>
                              </div>
                            )} */}

                          <NotificationsRoundedIcon
                            // onClick={openNotification}
                            onClick={toggleDrawer1(anchor, true)}
                            style={{ cursor: "pointer" }}
                          />
                          {notificationCount > 0 && (
                            <a
                              className="dropdown-toggle"
                              href="#"
                              role="button"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <div className="circle" style={{ fontSize: '12px', width: '17px', top: '-20px', height: '17px' }}>{notificationCount}</div>
                            </a>
                          )}
                        </div>
                        <SwipeableDrawer
                          anchor={anchor}
                          open={state[anchor]}
                          onClose={toggleDrawer1(anchor, false)}
                          onOpen={toggleDrawer1(anchor, true)}
                          style={{ zIndex: 99999 }}
                        >
                          {list(anchor)}
                        </SwipeableDrawer>
                      </React.Fragment>
                    ))}
                  </div>
                  <div className="dropdown" >
                    <div
                      className={
                        isNotificationOpen
                          ? "notifications dropdown-menu notification-show"
                          : "notifications dropdown-menu"
                      }
                    >
                      <div className="notifications_heading justify-content-between">
                        Notifications
                        {notificationCount > 0 && (
                          <span
                            onClick={clearNotification}
                            name="clear"
                            id="clear"
                          >
                            Clear
                          </span>
                        )}
                      </div>
                      <div className="notifications_inside notification-height-css" ref={wrapperRef}
                      >
                        <ul>
                          {notifications.map((ele, index) => (
                            <li key={index}>
                                 <div className="time_outer">
                                <img src="images/time.png" alt="" />{" "}
                                <AccessTimeIcon /><span>{strToDate(ele?.createdAt)}</span>
                              </div>
                              {ele?.data?.uniqueName ?
                                <a href={`${notifiURL(ele?.data?.uniqueName)}/${ele?.data?.referenceId}`} onClick={() => handleNotificationClick(index)}>
                                  {ele?.message}
                                </a>
                                : ele?.message}
                            </li>
                          ))}
                        </ul>
                        {/* )} */}

                        {notificationCount < 1 && (
                          <div className="empty-notification">
                            No Notification Found
                          </div>
                        )}
                        {isLoading && (
                          <div className="loading">
                            Loading more notifications...
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="user_box">
                {profileData && profileData.profilePic ? (
                  <img
                    src={profileData.profilePic}
                    className="profil_picc_navbar"
                    alt="Profile pic"
                  />
                ) : (
                  <img src={userImage} alt="" className="user_images" />
                )}
                <Stack direction="row" spacing={2}>
                  <div>
                    <Button
                      className="drop_listing_block"
                      ref={anchorRef}
                      id="composition-button"
                      aria-controls={open ? "composition-menu" : undefined}
                      aria-expanded={open ? "true" : undefined}
                      aria-haspopup="true"
                      onClick={handleToggle}
                    >
                      {!isMobile && UserObj?.name}
                      <ArrowDropDownIcon />
                    </Button>
                    <Popper
                      open={open}
                      anchorEl={anchorRef.current}
                      role={undefined}
                      placement="bottom-start"
                      transition
                      disablePortal
                    >
                      {({ TransitionProps, placement }) => (
                        <Grow
                          {...TransitionProps}
                          style={{
                            transformOrigin:
                              placement === "bottom-start"
                                ? "left top"
                                : "left bottom",
                          }}
                        >
                          <Paper>
                            <ClickAwayListener onClickAway={handleClose}>
                              <MenuList
                                autoFocusItem={open}
                                id="composition-menu"
                                aria-labelledby="composition-button"
                                onKeyDown={handleListKeyDown}
                              >
                                <MenuItem
                                  onClick={() =>
                                    navigateUrl(
                                      `/admin/profile/${UserObj?._id}`
                                    )
                                  }
                                >
                                  Profile
                                </MenuItem>
                                <MenuItem
                                  onClick={() => changePasswordModael()}
                                >
                                  Change Password
                                </MenuItem>
                                <MenuItem onClick={logout}>Logout</MenuItem>
                              </MenuList>
                            </ClickAwayListener>
                          </Paper>
                        </Grow>
                      )}
                    </Popper>
                  </div>
                </Stack>
              </div>
            </div>
          </div>
        </div>
      </header >
      <AlertComponent
        alertComponent={alertComponent}
        handleClose={handleClose}
      />
      <Modal
        open={createVendorOpen}
        onClose={inviteModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="lets_block_modal_listing">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="contactModalLabel">
                Reset Password
              </h5>
              <button
                type="button"
                className="btn-close"
                data-dismiss="modal"
                aria-label="Close"
                fdprocessedid="7f6r2r"
                onClick={inviteModalClose}
              ></button>
            </div>
            <div className="modal-body">
              <form id="">
                <div className="mb-4 position-relative">
                  <label className="mb-1 text-dark">New Password</label>
                  <input
                    type="text"
                    name="password"
                    className="form-control form-h"
                    onChange={onInputChange}
                    value={credential?.password}
                    placeholder="Enter your password"
                  />
                  <span className="lock">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="19"
                      height="19"
                      fill="currentColor"
                      className="bi bi-lock"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2m3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M5 8h6a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1" />
                    </svg>
                  </span>
                </div>
                <div className="mb-4 position-relative">
                  <label className="mb-1 text-dark">Confirm Password</label>
                  <input
                    type={isPassword ? "password" : "text"}
                    name="confirmPassword"
                    className="form-control form-h"
                    onChange={onInputChange}
                    value={credential?.confirmPassword}
                    placeholder="Confirm your password"
                  />
                  <span className="lock">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="19"
                      height="19"
                      fill="currentColor"
                      className="bi bi-lock"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2m3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M5 8h6a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1" />
                    </svg>
                  </span>

                  <span className="show-pass eye" onClick={passwordViewChange}>
                    {isPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                  </span>
                </div>

                <div className="clear_btn_status">
                  <button
                    type="button"
                    className="btn clear_btn"
                    data-dismiss="modal"
                    fdprocessedid="frel3"
                    onClick={inviteModalClose}
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    className="btn btn-success save_next_btn"
                    onClick={submitResetPassword}
                    fdprocessedid="q9hf9"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </Box>
      </Modal>
    </>
  );
}

export default AdminNavbar;
